"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NativeTrackingEventName = exports.TrackingEventName = exports.TrackingRuntimeAdBlockerState = exports.TrackingRuntimeMediaType = void 0;
var TrackingRuntimeMediaType;
(function (TrackingRuntimeMediaType) {
    TrackingRuntimeMediaType["AD"] = "ad";
    TrackingRuntimeMediaType["CONTENT"] = "content";
})(TrackingRuntimeMediaType = exports.TrackingRuntimeMediaType || (exports.TrackingRuntimeMediaType = {}));
var TrackingRuntimeAdBlockerState;
(function (TrackingRuntimeAdBlockerState) {
    TrackingRuntimeAdBlockerState["AD_BLOCKER"] = "ab";
    TrackingRuntimeAdBlockerState["NO_AD_BLOCKER"] = "noab";
})(TrackingRuntimeAdBlockerState = exports.TrackingRuntimeAdBlockerState || (exports.TrackingRuntimeAdBlockerState = {}));
var TrackingEventName;
(function (TrackingEventName) {
    TrackingEventName["LIFECYCLE_CREATE"] = "Lifecycle Create";
    TrackingEventName["LIFECYCLE_START"] = "Lifecycle Start";
    TrackingEventName["LIFECYCLE_ABORT"] = "Lifecycle Abort";
    TrackingEventName["LIFECYCLE_END"] = "Lifecycle End";
    TrackingEventName["CONTENT_LOADED"] = "Content Loaded";
    TrackingEventName["CONTENT_BEGIN"] = "Content Begin";
    TrackingEventName["STALL_STARTED"] = "Stall Started";
    TrackingEventName["STALL_ENDED"] = "Stall Ended";
    TrackingEventName["CONTENT_COMPLETE"] = "Content Complete";
    TrackingEventName["LIFECYCLE_PLAY_REJECTED"] = "Lifecycle Playreject";
    TrackingEventName["LIFECYCLE_PLAY"] = "Lifecycle Play";
    TrackingEventName["VIDEO_QUALITY_CHANGED"] = "Video Quality Changed";
    TrackingEventName["AD_VIDEO_QUALITY_CHANGED"] = "Ad Video Quality Changed";
    TrackingEventName["AD_LOADED"] = "Ad Loaded";
    TrackingEventName["AD_BEGIN"] = "Ad Begin";
    TrackingEventName["AD_VIDEO_FIRST_QUARTILE"] = "Ad Video First Quartile";
    TrackingEventName["AD_VIDEO_MIDPOINT"] = "Ad Video Midpoint";
    TrackingEventName["AD_VIDEO_THIRD_QUARTILE"] = "Ad Video Third Quartile";
    TrackingEventName["AD_IMPRESSION"] = "Ad Impression";
    TrackingEventName["AD_STALL_STARTED"] = "Ad Stall Started";
    TrackingEventName["AD_STALL_ENDED"] = "Ad Stall Ended";
    TrackingEventName["AD_ERROR"] = "Ad Error";
    TrackingEventName["AD_COMPLETE"] = "Ad Complete";
    TrackingEventName["AD_ROLL_START"] = "AdRoll Start";
    TrackingEventName["AD_ROLL_EMPTY"] = "AdRoll Empty";
    TrackingEventName["AD_ROLL_END"] = "AdRoll End";
    TrackingEventName["PLAYLIST_OPEN"] = "Playlist Open";
    TrackingEventName["PLAYLIST_CLOSE"] = "Playlist Close";
    TrackingEventName["FULLSCREEN_CHANGE"] = "Fullscreen Change";
    TrackingEventName["POSITION_CHANGE"] = "Position Change";
    TrackingEventName["POSITION_SEEK"] = "Position Seek";
    TrackingEventName["SKIP_INTRO"] = "Skip Intro";
    TrackingEventName["SEEK_START"] = "Seek Start";
    TrackingEventName["SEEKING"] = "Seeking";
    TrackingEventName["SEEKED"] = "Seeked";
    TrackingEventName["SEEK_END"] = "Seek End";
    TrackingEventName["TIMESHIFTING"] = "Time Shifting";
    TrackingEventName["TIMESHIFTED"] = "Time Shifted";
    TrackingEventName["VOLUME_CHANGE"] = "Volume Change";
    TrackingEventName["RESUME"] = "Resume";
    TrackingEventName["PAUSE"] = "Pause";
    TrackingEventName["AB_DISPLAY_NONE_DETECTED"] = "AB Display None Detected";
    TrackingEventName["AD_SCHEDULER_TIMED_OUT"] = "Ad Scheduler Timed Out";
    TrackingEventName["AD_CLICK_THROUGH"] = "Ad Click Through";
    TrackingEventName["AD_CLICK_THROUGH_BLOCKED"] = "Ad Click Through Blocked";
    TrackingEventName["APP_BACKGROUNDED"] = "App Backgrounded";
    TrackingEventName["APP_FOREGROUNDED"] = "App Foregrounded";
    TrackingEventName["ERROR"] = "Error";
    TrackingEventName["RECOMMENDATION_REPLAY"] = "Recommendation Replay";
    TrackingEventName["PLAY_RECOMMENDATION_INDEX"] = "Play Recommendation Index";
    TrackingEventName["RECOMMENDATION_AUTOPLAY_CANCELLED"] = "Recommendation Autoplay Cancelled";
    TrackingEventName["PLAYLIST_INDEX_CHANGED"] = "Playlist Index Changed";
    TrackingEventName["SKIP_TO_PLAYLIST_INDEX"] = "Skip To Playlist Index";
    TrackingEventName["SKIP_TO_PREVIOUS_VIDEO"] = "Skip To Previous Video";
    TrackingEventName["SKIP_TO_NEXT_VIDEO"] = "Skip To Next Video";
    TrackingEventName["SKIP_TO_NEXT_TEASER"] = "Skip To Next Teaser";
    TrackingEventName["KEYBOARD_MUTE"] = "Muted via keyboard";
    TrackingEventName["KEYBOARD_UNMUTE"] = "Unmuted via keyboard";
    TrackingEventName["KEYBOARD_PLAY"] = "Started video via keyboard";
    TrackingEventName["KEYBOARD_PAUSE"] = "Paused video via keyboard";
    TrackingEventName["KEYBOARD_ENTER_FULLSCREEN"] = "Enter fullscreen via keyboard";
    TrackingEventName["KEYBOARD_EXIT_FULLSCREEN"] = "Exit fullscreen via keyboard";
    TrackingEventName["KEYBOARD_SEEK_FORWARD"] = "Seeked forwards via keyboard";
    TrackingEventName["KEYBOARD_SEEK_BACKWARD"] = "Seeked backwards via keyboard";
    TrackingEventName["KEYBOARD_NEXT_VIDEO"] = "Switched to next video via keyboard";
    TrackingEventName["KEYBOARD_PREVIOUS_VIDEO"] = "Switched to previous video via keyboard";
    TrackingEventName["KEYBOARD_SET_VOLUME"] = "Toggled volume via keyboard";
    TrackingEventName["ALTERNATIVE_STREAMS_AVAILABLE"] = "Alternative Streams Available";
    TrackingEventName["ALTERNATIVE_STREAMS_UNAVAILABLE"] = "Alternative Streams Unavailable";
    TrackingEventName["SKIP_TO_ALTERNATIVE_STREAM"] = "Skip To Alternative Stream";
})(TrackingEventName = exports.TrackingEventName || (exports.TrackingEventName = {}));
// add here only events which are used exclusively on native
var NativeTrackingEventName;
(function (NativeTrackingEventName) {
    NativeTrackingEventName["SKIP_TO_TEASER"] = "Skip To Teaser";
})(NativeTrackingEventName = exports.NativeTrackingEventName || (exports.NativeTrackingEventName = {}));
//# sourceMappingURL=tracking.js.map